var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTipsClose = function SvgTipsClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.707 9.469a1 1 0 0 0-1.414-1.414L16 15.348 8.707 8.055a1 1 0 0 0-1.414 1.414l7.293 7.293-7.293 7.293a1 1 0 1 0 1.414 1.414L16 18.176l7.293 7.293a1 1 0 0 0 1.414-1.414l-7.293-7.293 7.293-7.293Z",
    fill: "#282828"
  })));
};
export default SvgTipsClose;